import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import logo from "../assets/icons/logo.png";
import "../assets/css/Signin.scss";
import { loginUser } from "../redux/feature/AuthSlice";
import ButtonLoader from "../atoms/buttonLoader";
import { LoginLogo } from "../assets/icons";
import { selectCurrentPlan } from "../redux/selectors/authSelectors";
import { setPlan } from "../redux/feature/AuthSlice";
import { normalizePlanName } from "../utils/planFeatureAccess";
import { FaEye, FaEyeSlash } from "react-icons/fa";


const Signin = () => {
  const currentPlan = useSelector(selectCurrentPlan);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [passwordType, setPasswordType] = useState("password");
  const [isLoading, setLoading] = useState(false);

  const togglePassword = () => {
    setPasswordType((prev) => (prev === "password" ? "text" : "password"));
  };

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    password: Yup.string().required("Password is required"),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    setLoading(true);
    try {
      const credentials = { ...values };
      const response = await dispatch(loginUser(credentials)).unwrap();
      if (response?.user) {
        localStorage.setItem('userData', JSON.stringify(response));
        const userPlan = normalizePlanName(response?.plan || "basic");
        dispatch(setPlan(userPlan));

        // Check if user is super admin
        const userRole = response?.user?.user?.role?.toLowerCase();
        if (userRole === 'super_admin') {
          // Super admin always goes to dashboard
          window.location.href = "/";
        } else if (userPlan === 'ultimate') {
          window.location.href = "/";
        } else {
          window.location.href = "/view-project";
        }
      }
    } catch (error) {
      // Error toast handled centrally in the auth slice
    }
    setLoading(false);
    setSubmitting(false);
  };

  return (
    <div className="fluid-container">
      <div className="sign-page">
        <div className="sign-page-background d-flex align-items-center">
          <div
            className="row m-0 sign-page-background-row"
            style={{ justifyContent: "center", alignItems: "center" }}
          >
            <div className="custome_offset px-lg-5 mahzen-logo d-flex justify-content-center flex-column">
              <div style={{ height: "100%", width: "100%" }}>
                <div className="row mx-lg-5 px-lg-5 pt-3 pb-2 siginup-inner py-5">
                  <div className="w-full d-flex justify-content-center">
                    <div className="login-logo d-flex justify-content-center align-items-end">
                      {LoginLogo}
                    </div>
                  </div>
                  <div className="col-12 mb-3 d-flex justify-content-center">
                    <p className="mb-0 text-[#1E3A8A] font-semibold text-[28px]">
                      Login
                    </p>
                  </div>
                  <Formik
                    initialValues={{ email: "", password: "" }}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                  >
                    {({ isSubmitting }) => (
                      <Form className="w-100">
                        <div className="col-12 mt-2 signup-input-label">
                          <Field
                            type="text"
                            name="email"
                            placeholder="Email"
                            className="form-control pl-3"
                          />
                          <ErrorMessage
                            name="email"
                            component="p"
                            className="signup-staric-color"
                          />
                        </div>
                        <div className="col-12 mt-4 mb-1 signup-input-label">
                          <div
                            className="d-flex border_custome"
                            style={{ height: "54px", borderRadius: "8px" }}
                          >
                            <Field
                              type={passwordType}
                              name="password"
                              placeholder="Password"
                              className="form-control pl-3"
                              style={{ border: "none", backgroundColor: "transparent" }}
                            />
                            <div className="loginPasswordPositionBottom input-group-btn">
                              <span
                                className="eyeBtn pr-3"
                                onClick={togglePassword}
                                style={{ cursor: "pointer" }}
                              >
                                {passwordType === "password" ? (
                                  <FaEyeSlash color="#4B5563" size={16} />
                                ) : (
                                  <FaEye color="#4B5563" size={16} />
                                )}
                              </span>
                            </div>
                          </div>
                          <ErrorMessage
                            name="password"
                            component="p"
                            className="signup-staric-color"
                          />
                          <div className="text-right mt-2">
                            <Link
                              to="/forgotpassword"
                              className="text-[#F97316] text-[14px] hover:underline"
                            >
                              Forgot Password?
                            </Link>
                          </div>
                        </div>
                        <div className="w-full flex justify-center items-center">
                          <button
                            type="submit"
                            className="w-[94.5%] bg-[#F97316] h-[52px] rounded-[4px] mt-6 flex items-center justify-center"
                            disabled={isSubmitting || isLoading}
                          >
                            {isLoading ? (
                              <ButtonLoader color="#FFFFFF" />
                            ) : (
                              <p className="font-semibold text-[20px] text-white">
                                Log in
                              </p>
                            )}
                          </button>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signin;
